import { Link } from "@inertiajs/react"
import { MessageSquare } from "lucide-react"
import { cn } from "@/lib/utils"

const TABS = [
  { key: "content",  label: "Content"  },
  { key: "activity", label: "Activity" },
] as const

export type PieceTabKey = (typeof TABS)[number]["key"]

// Two-tab sub-navigation for a single piece's detail view. The Activity
// tab gets a small bubble showing the comment count when > 0.
export function PieceSubNav({
  pieceId,
  active,
  commentCount = 0,
}: {
  pieceId: number
  active: PieceTabKey
  commentCount?: number
}) {
  return (
    <nav className="flex flex-wrap items-end gap-6 border-b border-hairline">
      {TABS.map((tab) => {
        const isActive = tab.key === active
        const href =
          tab.key === "content"
            ? `/pieces/${pieceId}`
            : `/pieces/${pieceId}/${tab.key}`
        return (
          <Link
            key={tab.key}
            href={href}
            className={cn(
              "-mb-px inline-flex items-center gap-1.5 border-b-2 px-1 py-3 text-sm no-underline",
              isActive
                ? "border-accent font-medium text-accent-display"
                : "border-transparent text-ink-body hover:text-ink-display",
            )}
          >
            {tab.label}
            {tab.key === "activity" && commentCount > 0 && (
              <span className="inline-flex items-center gap-0.5 rounded-full border border-hairline px-1.5 py-0.5 text-[10px] leading-none font-normal text-ink-muted">
                <MessageSquare className="h-2.5 w-2.5" />
                {commentCount}
              </span>
            )}
          </Link>
        )
      })}
    </nav>
  )
}
